import { Toast } from "mint-ui";
export default class {
    //验证手机
    CheckPhone(phone) {
        if (!phone) {
            Toast({
                message: "请输入手机号码",
                position: "bottom",
                duration: 1500
            });
            return false;

        } else {
            return true;
        }
    }
    //appId
    encryption(data) {
        data.AppId = "quanmaikai";
        let strs = [];
        for (let i in data) {
            strs.push(i + '=' + encodeURIComponent(data[i]));
        }
        strs.sort();  // 数组排序
        strs = strs.join(''); // 数组变字符串
        return data;
    }
    //时间格式转换  1993-11-11
    FormatDate(time, needHour, noNeedYear) {
        if (time) {
            let date = new Date(time);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let M = date.getMinutes();
            M = M < 10 ? "0" + M : M;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            if (needHour) {
                return y + "-" + m + "-" + d + " " + h + ":" + M + ":" + s;
            }
            if (noNeedYear) {
                if (needHour) {
                    return `${m}-${d} ${h}:${M}:${s}`;
                }
                return `${m}-${d}`;
            }
            return y + "-" + m + "-" + d;
        } else {
            return '';
        }
    }
    //将时间戳转换为时间格式（年月日时分秒）
    timestampToTime(timestamp, day) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        if (day) {
            return Y + M + D;
        } else {
            return Y + M + D + h + m + s;
        }
    }
    //将当前时间转化为年月日
    getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    }
    //早中晚
    getTime() {
        var now = new Date();
        var hour= Number(now.getHours())
        var text = ''
        if (0 <= hour&& hour < 5) {
            text = '凌晨好'
        } else if (5 <=hour&&hour < 7) {
            text = '早上好'
        } else if (7<=hour&& hour < 12) {
            text = '上午好'
        } else if (12 <=hour&&hour < 14) {
            text = '中午好'
        } else if (14 <=hour&& hour < 17) {
            text = '下午好'
        } else if (17<=hour&&hour <24) {
            text = '晚上好'
        }
        return text;
    }
}



// WEBPACK FOOTER //
// ./src/util/base.js